<b>Jobs by Vehicle Type</b>
<hr>
<ngx-charts-bar-vertical-stacked
  [view]="view"
  [scheme]="colorScheme"
  [results]="dataGraph1"
  [gradient]="gradient"
  [xAxis]="showXAxis"
  [yAxis]="showYAxis"
  [legend]="showLegendGraph1"
  [showXAxisLabel]="showXAxisLabel"
  [showYAxisLabel]="showYAxisLabel"
  [xAxisLabel]="xAxisLabelGraph1"
  [yAxisLabel]="yAxisLabelGraph1"
  [animations]="animations">
</ngx-charts-bar-vertical-stacked>
